var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGetNotified(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 56,
    height: 54,
    viewBox: "0 0 56 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "jdldwkdiua",
    d: "M0 0.19L55.839 0.19 55.839 54 0 54z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-160 -1486) translate(160 1486)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "h8mfqx3f9b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#jdldwkdiua"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FA7700",
    d: "M53.404 38.637h-9.291c-1.165 0-2.112.96-2.112 2.141v10.085c-2.16-2.966-5.621-7.74-8.158-11.333-.395-.56-1.037-.893-1.716-.893H2.435V2.658h50.969v35.979zM53.727.19H2.112C.948.19 0 1.15 0 2.33v36.634c0 1.181.948 2.142 2.112 2.142h29.849c2.782 3.937 6.613 9.212 8.665 12.025.406.557 1.04.87 1.696.87.22 0 .444-.036.662-.11.868-.29 1.451-1.107 1.451-2.034V41.106h9.292c1.164 0 2.112-.961 2.112-2.142V2.331c0-1.18-.948-2.141-2.112-2.141z",
    mask: "url(#h8mfqx3f9b)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FA7700",
    d: "M22.543 29.463l.847.912 17.337-18.447-1.694-1.803L23.4 26.759c-3.034-3.264-6.338-6.799-6.65-7.048l-1.439 2.04-.038-.033c.398.367 4.67 4.945 7.27 7.745",
    transform: "translate(-160 -1486) translate(160 1486)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetNotified);
export default __webpack_public_path__ + "static/media/get-notified.78ab290a.svg";
export { ForwardRef as ReactComponent };